import { render, staticRenderFns } from "./StatusInfo.vue?vue&type=template&id=aea906d6&scoped=true&"
import script from "./StatusInfo.vue?vue&type=script&lang=ts&"
export * from "./StatusInfo.vue?vue&type=script&lang=ts&"
import style0 from "./StatusInfo.vue?vue&type=style&index=0&id=aea906d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea906d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})
